import React, { useCallback, useEffect, useRef } from 'react';
import { FiLogIn, FiMail } from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';

import {
  setIsCategory,
  viewModal,
} from '../../store/modules/parameter/actions';

import getValidationErrors from '../../utils/getValidationErrors';
import {config} from '../../config';
import Input from '../../components/Input';
import Button from '../../components/Button';

import {
  AnimationContainer,
  Background,
  ColInput,
  Container,
  Content,
  MessageFromApi,
} from './styles';

import SignIn from '../SignIn';

import {
  customerForgotPassword,
  customerForgotPasswordClear,
} from '../../store/modules/auth/actions';

import { StoreState } from '../../store/createStore';

interface ForgotPasswordFormData {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const { forgotPasswordReq, passwordMessage } = useSelector(
    (state: StoreState) => state.auth,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsCategory(false));
  }, [dispatch]);

  const handleBackToState1 = useCallback(() => {
    dispatch(customerForgotPasswordClear());

    dispatch(viewModal(SignIn, { width: '50%', height: '100%' }));
  }, [dispatch]);

  const handleSubmit = useCallback(
    async (data: ForgotPasswordFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()

            .required('E-mail obrigatório')

            .email('Digite um e-mail válido'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        dispatch(customerForgotPassword(data.email));

        // addToast....
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
        }

        // addToast({

        //   type: 'error',

        //   title: 'TypeScript',

        //   description: 'Show de bola typescript!!!!',

        // });
      }
    },

    [dispatch],
  );

  // useEffect(() => {
  //   if (forgotPasswordOk && passwordMessage) {
  //     dispatch(openShowModal(false));

  //     dispatch(customerForgotPasswordClear());

  //     onSetMessage({ type: 'success', description: passwordMessage });
  //   }
  // }, [forgotPasswordOk, passwordMessage, dispatch, onSetMessage]);

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={config.logo} alt="ConectoGO" />

          <Form
            // initialData={{

            //   email: 'wfelix@conecto.com.br',

            // }}

            ref={formRef}
            onSubmit={handleSubmit}
          >
            <ColInput>
              <h1>Recuperar senha</h1>
            </ColInput>

            <ColInput>
              <Input
                type="text"
                icon={FiMail}
                name="email"
                placeholder="E-mail"
              />
            </ColInput>

            <ColInput>
              <Button
                atributes={{
                  buttonType: 'primary',

                  textColor: '#fff',

                  textSize: '30px',

                  borderColor: '#dddddd',
                }}
                button={{ type: 'submit' }}
              >
                {!forgotPasswordReq ? 'Recuperar' : 'Aguarde...'}
              </Button>
            </ColInput>

            <ColInput>
              <MessageFromApi>
                {passwordMessage !== '' ? <b>{passwordMessage}</b> : ''}
              </MessageFromApi>
            </ColInput>
          </Form>

          <ColInput onClick={handleBackToState1}>
            <span>
              <FiLogIn />
              &nbsp; <b>Voltar</b>
            </span>
          </ColInput>
        </AnimationContainer>
      </Content>

      <Background />
    </Container>
  );
};

export default ForgotPassword;
